import { ERP_DRIVEN_PRIMARY_ADDRESS_VALUE } from '@epicuro-next/data/baskets';
import { OrderHeader } from '@epicuro-next/data/order-book';
import { Order } from 'graphql-api/baskets-api-interfaces';

export function mapDetailsDropShipAddress(
  details: Order,
  orderHeader: OrderHeader,
): Order {
  const [addressData] = orderHeader.addresses;
  const isEMEADropShip =
    orderHeader.addresses.length === 1 &&
    addressData.street1 === ERP_DRIVEN_PRIMARY_ADDRESS_VALUE;

  if (isEMEADropShip) {
    const address = `${addressData.city}, ${addressData.street2}, ${addressData.zipCode}`;

    return {
      ...details,
      address,
    };
  }

  return details;
}
